
import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "../assets/img/logo.png";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import CryptoJS from "crypto-js";
// import "./ResetPassword.css";

function ResetPassword() {
  const [email, setEmail] = useState("");
  const [otp, setOtp] = useState("");
  const [password, setPassword] = useState("");
  const [cnfPassword, setCnfPassword] = useState("");

  const [otpSent, setOtpSent] = useState(false);
  const [loading, setLoading] = useState(false);

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const [passwordError, setPasswordError] = useState("");
  const [cnfPasswordError, setCnfPasswordError] = useState("");
  const [error, setError] = useState("");

  const secretKey = "fship-password-10";
  const navigate = useNavigate();
  const apiUrl = process.env.REACT_APP_URL;

  // Password must contain at least one alphabet and one number.
  const passwordRegex = /^(?=.*[A-Za-z])(?=.*\d).+$/;

  // =========================================
  // SEND OTP
  // =========================================
  const handleSendOtp = async (e) => {
    e.preventDefault();
    setError("");

    if (!email.trim()) {
      setError("Please enter your email address.");
      return;
    }

    setLoading(true);

    try {
      const response = await fetch(
        `${apiUrl}/employee/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim(),
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.status === "success") {
        if (responseData?.data?.Token) {
          localStorage.setItem(
            "_ux98c_v1",
            responseData.data.Token
          );
        }

        toast.success(
          responseData.message || "OTP sent successfully."
        );

        setOtpSent(true);
      } else {
        toast.error(
          responseData.message || "Unable to send OTP."
        );
      }
    } catch (err) {
      console.error("Send OTP error:", err);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  // =========================================
  // PASSWORD VALIDATION
  // =========================================
  const handlePasswordChange = (e) => {
    const value = e.target.value;

    setPassword(value);

    if (!value) {
      setPasswordError("Please enter a new password.");
    } else if (!passwordRegex.test(value)) {
      setPasswordError(
        "Password must contain at least one alphabet and one number."
      );
    } else {
      setPasswordError("");
    }

    if (cnfPassword && value !== cnfPassword) {
      setCnfPasswordError("Passwords do not match.");
    } else if (cnfPassword) {
      setCnfPasswordError("");
    }
  };

  // =========================================
  // CONFIRM PASSWORD VALIDATION
  // =========================================
  const handleCnfPasswordChange = (e) => {
    const value = e.target.value;

    setCnfPassword(value);

    if (!value) {
      setCnfPasswordError("Please confirm your password.");
    } else if (!passwordRegex.test(value)) {
      setCnfPasswordError(
        "Password must contain at least one alphabet and one number."
      );
    } else if (value !== password) {
      setCnfPasswordError("Passwords do not match.");
    } else {
      setCnfPasswordError("");
    }
  };

  // =========================================
  // RESET PASSWORD
  // =========================================
  const handleResetPassword = async (e) => {
    e.preventDefault();
    setError("");

    if (!otp.trim()) {
      setError("Please enter the OTP.");
      return;
    }

    if (!password || !cnfPassword) {
      setError("Please enter and confirm your password.");
      return;
    }

    if (!passwordRegex.test(password)) {
      setPasswordError(
        "Password must contain at least one alphabet and one number."
      );
      return;
    }

    // Compare original passwords before encryption
    if (password !== cnfPassword) {
      setCnfPasswordError("Passwords do not match.");
      return;
    }

    setPasswordError("");
    setCnfPasswordError("");

    // Encrypt password once.
    // Send the same encrypted value in both fields,
    // following the old working implementation.
    const encryptedPassword = CryptoJS.AES.encrypt(
      password,
      secretKey
    ).toString();

    setLoading(true);

    try {
      const response = await fetch(
        `${apiUrl}/employee/reset-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim(),
            otp: otp.trim(),
            newPassword: encryptedPassword,
            confirmPassword: encryptedPassword,
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.status === "success") {
        toast.success(
          "Password changed successfully!"
        );

        setTimeout(() => {
          navigate("/");
        }, 1200);
      } else {
        toast.error(
          responseData.message || "Unable to reset password."
        );
      }
    } catch (err) {
      console.error("Reset password error:", err);
      toast.error(
        "Something went wrong. Please try again."
      );
    } finally {
      setLoading(false);
    }
  };

  // =========================================
  // RESEND OTP
  // =========================================
  const handleResendOtp = async () => {
    setLoading(true);

    try {
      const response = await fetch(
        `${apiUrl}/employee/forgot-password`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            email: email.trim(),
          }),
        }
      );

      const responseData = await response.json();

      if (responseData.status === "success") {
        if (responseData?.data?.Token) {
          localStorage.setItem(
            "_ux98c_v1",
            responseData.data.Token
          );
        }

        toast.success(
          responseData.message || "OTP sent again."
        );
      } else {
        toast.error(
          responseData.message || "Unable to resend OTP."
        );
      }
    } catch (err) {
      console.error("Resend OTP error:", err);
      toast.error("Unable to resend OTP.");
    } finally {
      setLoading(false);
    }
  };

  // =========================================
  // UI
  // =========================================
  return (
    <div className="fship-reset-page">

      <ToastContainer
        position="top-right"
        autoClose={2500}
        theme="colored"
      />

      {loading && (
        <div className="fship-reset-loader">
          <div className="fship-reset-spinner"></div>
          <span>Please wait...</span>
        </div>
      )}

      <main className="fship-reset-container">

        {/* LEFT BRAND PANEL */}
        <section className="fship-reset-brand">

          <div className="fship-reset-brand-header">
            <div className="fship-reset-logo-circle">
              <img src={logo} alt="Fship Logo" />
            </div>

            <div className="fship-reset-brand-divider"></div>

            <div className="fship-reset-brand-caption">
              <span>BUSINESS</span>
              <strong>CRM PLATFORM</strong>
            </div>
          </div>

          <div className="fship-reset-brand-content">

            <span className="fship-reset-brand-badge">
              <span></span>
              ACCOUNT SECURITY
            </span>

            <h1>
              Your security,
              <br />
              <span>our priority.</span>
            </h1>

            <p>
              Securely recover access to your Fship CRM account.
              Verify your email, create your new password and get
              back to managing your business.
            </p>

            <div className="fship-reset-security-list">

              <div className="fship-reset-security-item">
                <div className="fship-reset-security-icon">
                  <svg viewBox="0 0 24 24">
                    <rect x="4" y="10" width="16" height="11" rx="2" />
                    <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                  </svg>
                </div>

                <div>
                  <strong>Secure Verification</strong>
                  <span>OTP-based account verification</span>
                </div>
              </div>

              <div className="fship-reset-security-item">
                <div className="fship-reset-security-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z" />
                    <path d="m9 12 2 2 4-4" />
                  </svg>
                </div>

                <div>
                  <strong>Protected Account</strong>
                  <span>Your account security matters</span>
                </div>
              </div>

              <div className="fship-reset-security-item">
                <div className="fship-reset-security-icon">
                  <svg viewBox="0 0 24 24">
                    <path d="M3 12a9 9 0 1 0 3-6.7" />
                    <path d="M3 4v5h5" />
                    <path d="M12 7v5l3 2" />
                  </svg>
                </div>

                <div>
                  <strong>Quick Recovery</strong>
                  <span>Get back to work without delay</span>
                </div>
              </div>

            </div>
          </div>

          <div className="fship-reset-brand-footer">
            <span>© 2024 Fship CRM</span>
            <span>Built for smarter business management</span>
          </div>

          <div className="fship-reset-circle circle-one"></div>
          <div className="fship-reset-circle circle-two"></div>

        </section>

        {/* RIGHT RESET FORM PANEL */}
        <section className="fship-reset-form-panel">

          <div className="fship-reset-form-card">

            {/* MOBILE LOGO */}
            <div className="fship-reset-mobile-logo">
              <div className="fship-reset-logo-circle">
                <img src={logo} alt="Fship Logo" />
              </div>
              <span>BUSINESS CRM</span>
            </div>

            <Link to="/" className="fship-reset-back-link">
              <svg viewBox="0 0 24 24">
                <path d="M19 12H5M11 18l-6-6 6-6" />
              </svg>
              Back to Login
            </Link>

            <div className="fship-reset-heading">

              <span className="fship-reset-heading-tag">
                {otpSent ? "VERIFY & UPDATE" : "ACCOUNT RECOVERY"}
              </span>

              <div className="fship-reset-heading-icon">
                <svg viewBox="0 0 24 24">
                  <rect x="4" y="10" width="16" height="11" rx="2" />
                  <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                  <path d="M12 14v3" />
                </svg>
              </div>

              <h2>
                {otpSent ? "Create new password" : "Forgot password?"}
              </h2>

              <p>
                {otpSent
                  ? `Enter the OTP sent to ${email} and create your new password.`
                  : "Don't worry! Enter your registered email address and we'll send you an OTP to reset your password."}
              </p>
            </div>

            {/* STEP INDICATOR */}
            <div className="fship-reset-steps">

              <div className="fship-reset-step active">
                <span>{otpSent ? "✓" : "1"}</span>
                <small>Email</small>
              </div>

              <div className={`fship-reset-step-line ${otpSent ? "active" : ""}`}></div>

              <div className={`fship-reset-step ${otpSent ? "active" : ""}`}>
                <span>2</span>
                <small>Verify OTP</small>
              </div>

              <div className={`fship-reset-step-line ${otpSent ? "active" : ""}`}></div>

              <div className={`fship-reset-step ${otpSent ? "active" : ""}`}>
                <span>3</span>
                <small>New Password</small>
              </div>

            </div>

            <form onSubmit={otpSent ? handleResetPassword : handleSendOtp}>

              {/* EMAIL */}
              {!otpSent && (
                <div className="fship-reset-field">
                  <label htmlFor="reset-email">
                    Registered Email Address
                  </label>

                  <div className="fship-reset-input">
                    <svg viewBox="0 0 24 24">
                      <rect x="3" y="5" width="18" height="14" rx="2" />
                      <path d="m3 7 9 6 9-6" />
                    </svg>

                    <input
                      id="reset-email"
                      type="email"
                      placeholder="name@company.com"
                      value={email}
                      onChange={(e) => {
                        setEmail(e.target.value);
                        setError("");
                      }}
                      autoComplete="email"
                      required
                    />
                  </div>
                </div>
              )}

              {/* OTP AND PASSWORD FIELDS */}
              {otpSent && (
                <>
                  {/* OTP */}
                  <div className="fship-reset-field">
                    <label htmlFor="reset-otp">
                      Verification OTP
                    </label>

                    <div className="fship-reset-input">
                      <svg viewBox="0 0 24 24">
                        <rect x="3" y="5" width="18" height="14" rx="2" />
                        <path d="M7 10h.01M12 10h.01M17 10h.01M7 14h10" />
                      </svg>

                      <input
                        id="reset-otp"
                        type="text"
                        placeholder="Enter received OTP"
                        value={otp}
                        onChange={(e) => {
                          setOtp(e.target.value);
                          setError("");
                        }}
                        autoComplete="one-time-code"
                        required
                      />
                    </div>

                    <div className="fship-reset-resend">
                      <span>Didn't receive OTP?</span>

                      <button
                        type="button"
                        onClick={handleResendOtp}
                        disabled={loading}
                      >
                        Resend OTP
                      </button>
                    </div>
                  </div>

                  {/* NEW PASSWORD */}
                  <div className="fship-reset-field">
                    <label htmlFor="reset-password">
                      New Password
                    </label>

                    <div className="fship-reset-input">
                      <svg viewBox="0 0 24 24">
                        <rect x="4" y="10" width="16" height="11" rx="2" />
                        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                      </svg>

                      <input
                        id="reset-password"
                        type={showPassword ? "text" : "password"}
                        placeholder="Enter new password"
                        value={password}
                        onChange={handlePasswordChange}
                        autoComplete="new-password"
                        required
                      />

                      <button
                        type="button"
                        className="fship-reset-toggle"
                        onClick={() => setShowPassword(!showPassword)}
                      >
                        {showPassword ? "Hide" : "Show"}
                      </button>
                    </div>

                    {passwordError && (
                      <small className="fship-reset-validation-error">
                        {passwordError}
                      </small>
                    )}
                  </div>

                  {/* CONFIRM PASSWORD */}
                  <div className="fship-reset-field">
                    <label htmlFor="reset-confirm-password">
                      Confirm New Password
                    </label>

                    <div className="fship-reset-input">
                      <svg viewBox="0 0 24 24">
                        <rect x="4" y="10" width="16" height="11" rx="2" />
                        <path d="M8 10V7a4 4 0 0 1 8 0v3" />
                      </svg>

                      <input
                        id="reset-confirm-password"
                        type={showConfirmPassword ? "text" : "password"}
                        placeholder="Confirm your new password"
                        value={cnfPassword}
                        onChange={handleCnfPasswordChange}
                        autoComplete="new-password"
                        required
                      />

                      <button
                        type="button"
                        className="fship-reset-toggle"
                        onClick={() =>
                          setShowConfirmPassword(!showConfirmPassword)
                        }
                      >
                        {showConfirmPassword ? "Hide" : "Show"}
                      </button>
                    </div>

                    {cnfPasswordError && (
                      <small className="fship-reset-validation-error">
                        {cnfPasswordError}
                      </small>
                    )}
                  </div>
                </>
              )}

              {/* COMMON ERROR */}
              {error && (
                <div className="fship-reset-error">
                  <span>!</span>
                  {error}
                </div>
              )}

              {/* SUBMIT BUTTON */}
              <button
                type="submit"
                className="fship-reset-submit"
                disabled={loading}
              >
                <span>
                  {loading
                    ? "Please wait..."
                    : otpSent
                    ? "Change Password"
                    : "Send Verification OTP"}
                </span>

                {!loading && (
                  <svg viewBox="0 0 24 24">
                    <path d="M5 12h14M13 6l6 6-6 6" />
                  </svg>
                )}
              </button>

            </form>

            <div className="fship-reset-divider">
              <span></span>
              <small>SECURE ACCOUNT RECOVERY</small>
              <span></span>
            </div>

            <div className="fship-reset-bottom">
              <svg viewBox="0 0 24 24">
                <path d="M12 22s8-4 8-11V5l-8-3-8 3v6c0 7 8 11 8 11Z" />
                <path d="m9 12 2 2 4-4" />
              </svg>
              Your account security is important to us.
            </div>

          </div>

          <div className="fship-reset-panel-footer">
            © {new Date().getFullYear()} Fship. All rights reserved.
          </div>

        </section>

      </main>
    </div>
  );
}

export default ResetPassword;
